import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../environments/environment';
import {BusinessLogicModel} from '../../business-logic/business-logic.model';
import {ProjectBusinessLogicFilterService} from './project-business-logic-filter.service';
import {idAll} from './project-business-logic-filter-utils';

@Injectable({
  providedIn: 'root'
})
export class BusinessLogicListService {

  constructor(
    private http: HttpClient
  ) { }

  public getBusinessLogics(projectId: number): Observable<BusinessLogicModel[]> {
    let httpParams =
      (new HttpParams())
        .append('per-page', '1000')
        .append('page', '1')
        .append('expand', 'unitTypeNameIndex,project_custom_name')
        .append('fields', 'id,project_id,type,custom_name')
    ;
    if (projectId !== idAll) {
      httpParams = httpParams.append('BusinessLogicSearch[project_id]', projectId.toString());
    }
    return this.http.get<BusinessLogicModel[]>(
      environment.apiBasepoint + 'business-logic',
      {
        observe: 'body',
        params: httpParams
      }
    );
  }
}
